//Jquery element animations on scroll

(function($) {

  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function(partial) {
    
      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;
    
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };
    
})(jQuery);

$('#fixed-nav-trays a#updates').on('click', function() {
  $('#fixed-nav-trays' ).addClass('tray-closed');
});
$('#fixed-nav-trays a#search').on('click', function() {
  $('#fixed-nav-trays' ).addClass('tray-closed');
});
$('button.nav-tray-close').on('click', function() {
  $('#fixed-nav-trays' ).removeClass('tray-closed');
});
$('.js-off-canvas-overlay').on('click', function() {
  $('#fixed-nav-trays' ).removeClass('tray-closed');
});

//Important Update Notification
// var bodyClasses = [];
// var postsSeen = localStorage.getItem("postsSeen");
// $('#off-canvas-posts .post-card').each(function(){
//     var id = $(this).attr('id');
//     bodyClasses.push(id);
// });
// if (postsSeen) {
//   postsSeen = JSON.parse(postsSeen);
// } else {
//   postsSeen = [];
// }

// bodyClasses.forEach((bodyClass) => {
//   var postId = bodyClass;

//   if (!postsSeen.includes(postId)) {
//     $('#updates .notification').removeClass('off');
//     $('#updates').on('click', function() {
//       postsSeen.push(postId);
//       localStorage.setItem("postsSeen", JSON.stringify(postsSeen));
//       $('#updates .notification').addClass('off');
//     })
//   } else {
//     $('#updates .notification').addClass('off');
//   }
// });

  // Add the post id to localStorage to track which posts have been seen.
  var bodyClasses = jQuery.makeArray(jQuery("body")[0].classList);
  var postsSeen = localStorage.getItem("postsSeen");

  if (postsSeen) {
    postsSeen = JSON.parse(postsSeen);
  } else {
    postsSeen = [];
  }

  bodyClasses.forEach((bodyClass) => {
    var classStrings = bodyClass.split("-");

    if (classStrings[0] === "postid" && classStrings[1]) {
      var postId = classStrings[1];

      if (!postsSeen.includes(postId)) {
        postsSeen.push(postId);
        localStorage.setItem("postsSeen", JSON.stringify(postsSeen));
      }
    }
  });

  // Remove seen posts.
  var featuredPostsWrapper = jQuery("#off-canvas-posts");

  featuredPostsWrapper.find("article").each((i, featuredPost) => {
    var postId = featuredPost.id.split("-")[1];

    if (postId && postsSeen.includes(postId)) {
      featuredPost.remove();
    }
  });

  // Update badge count.
  var numberOfFeaturedPosts = featuredPostsWrapper.find("article").length;
  var badge = jQuery("#updates .notification");

  if (!numberOfFeaturedPosts) {
    badge.addClass("off");
    jQuery("#off-canvas-posts .content").append("<p>Nothing new to show. Check back for updates.</p>");
  }

$(document).ready(function(){
  $('.mobile-toggle').click(function(){
    $(this).toggleClass('open');
  });
});